module.exports = __webpack_public_path__ + "static/img/no2.fb23b7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no2.png
// module id = iClU
// module chunks = 31